import type { TranslatedString } from '@interfaces/shared';

export type WidgetAdditionalInfoProps = {
  showAdditionalInformation?: boolean;
  additionalInformation?: TranslatedString;
};

export const widgetAdditionalInfo = (
  translateBackendString: (translatedObject: unknown) => string,
  additionalInfoOpts: WidgetAdditionalInfoProps | undefined | null,
): string | undefined => {
  if (
    additionalInfoOpts?.showAdditionalInformation &&
    additionalInfoOpts.additionalInformation
  ) {
    return translateBackendString(additionalInfoOpts.additionalInformation);
  }
  return undefined;
};
